$('body').on('change', '.box-produto [name=porcao_id]', function() {
	var $self = $(this); 
	var $box = $self.closest('.box-produto');
	var $option = $self.find('option:selected');
	var row = $option.data()||{};
	if (undefined !== row.row) {
		row =  row.row;
	}
	var $preco_de = $box.find('.preco-de');
	var $preco_por = $box.find('.preco-por');
	var $calorias = $box.find('.calorias');

	var calorias = row.calorias|0;
	if (calorias != 0) {
		$calorias.html(row.calorias+'kcal');			
	} else {
		$calorias.html('');
	}

	var promocional = false;
	if ($preco_de.length != 0) {
		promocional = true;
	}

	var valor = (row.valor+'').number_format(2,',','.');
	var valor_promocional = (row.valor_promocional+'').number_format(2,',','.');
	
	if (0 >= row.valor*1.0 + row.valor_promocional*1.0) {

		$box.find('.preco_de, .preco_por').hide();

		$box.find('.btn-add-cart').hide();
		$box.find('.add-quantidade').hide();
		$box.find('.add-quantidade').parent().find('label').hide();

		return;
	} else {
		$box.find('.preco_de, .preco_por').show();
		$box.find('.btn-add-cart').show();
		$box.find('.add-quantidade').show();
		$box.find('.add-quantidade').parent().find('label').show();
	}

	if (promocional) {
		valor = `de R$ ${valor}`;
		valor_promocional = `por R$ ${valor_promocional}`;
		$preco_de.html(valor);
		$preco_por.html(valor_promocional);
	} else {
		valor = `R$ ${valor}`;
		$preco_por.html(valor);
	}
	


	$box.find('.add-quantidade').data('max',row.estoque);
	$box.find('.add-quantidade :text').trigger('change');
});
$('.box-produto [name=porcao_id]').trigger('change');

/*
 * quantidade dos produtos
 */

$('body').on('submit','[name=formProdutoQuantidade]', function() {
	return false;
});



$('body').on('change','[name=formProdutoQuantidade] [name=quantidade]', function() {
	try	{
		var $self = $(this);
		var $table = $self.closest('table');
		var $form =  $self.closest('form');
		var timer = $self.data('timer');
		var $tr = $self.closest('tr');
		var $valor = $tr.find('span[data-valor]');
		
		var $valor_total = $('.valor_total_carrinho');
		var $total_quantidade = $('.total-items');


		(function($table, $total_quantidade, $valor_total){

			var quantidade = $table.find('[name=quantidade]').map(function(){
				return $(this).val()|0;
			}).toArray().reduce(function(v, quantidade){
				return v+quantidade;
			},0);

			$total_quantidade.html(quantidade);

			var total = $table.find('[name=quantidade]').map(function(){
				return $(this).val()*$(this).data('valor');
			}).toArray().reduce(function(v, valor){
				return v+valor;
			},0.0);	
		
			$valor_total.html(total.number_format(2,',','.'));


		}($table, $total_quantidade, $valor_total));



		var quantidade = $self.val()|0;
		var valor = $valor.data('valor')*1.0;

		var valor = valor*quantidade;
		valor = valor.number_format(2,',','.');
		$valor.html(valor);

		if (timer) {
			window.clearTimeout(timer);
		}

		timer = window.setTimeout(function() {

			jQuery.fancybox.showLoading();


			var callback = function(resp) {
				$self.data('timer',null);

				if (undefined != resp.redirect_url) {
					location.href = resp.redirect_url;
					return;
				}

				jQuery.fancybox.hideLoading();
				if (undefined != resp.popup_url) {
					jQuery.fancybox.open([{
						href: resp.popup_url,
						type: 'ajax'
					}],{});
					return;
				}

				if (resp.success) {
					var subtotal = resp.subtotal*1.0;
					subtotal = subtotal.number_format(2,',','.');

					console.log(subtotal, resp);

					$('.valor_total_carrinho').html(subtotal);

					$('.total-items').html(resp.count);
				} else {
					alert(resp.msg);
					//location.reload(true);
				}
			};

			$.ajax({
				url: 'carrinho/set-quantidade',
				type: 'post',
				dataType: 'json',
				data: $form.serializeArray(),
				success: callback,
				error: function() {
					callback({
						success: false,
						msg: "Não foi possível alterar a quantidade do item."
					});
				}
			});

		}, 1000);

		$self.data('timer',timer);


	} catch (e) {
		console.log(e);
	}

	return false;
});


//////////////////
// WEBPACK FOOTER
// ../src/produto/index.js
// module id = 62
// module chunks = 0